import CLC2UniPage from "./CLC2UniPage";

export default CLC2UniPage;
